module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/text-mv-duedate-c6001b5263f098ece58adf2519a0608a.svg";